import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  Input,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UUID } from "angular2-uuid";
import { CropDataTool } from "../../shared/classes/cropdatatoolModel";
import { POP } from "../../shared/classes/popModel";
import { CropData } from "../../shared/classes/cropdataModel";
import { ngxLoadingAnimationTypes, NgxLoadingComponent } from "ngx-loading";
import { AuthenticateService } from "../../shared/services/authenticate.service";
import { CropsService } from "src/app/shared/services/crops.service";
import { ProfileService } from "src/app/shared/services/profile.service";
import { TokenStorageService } from "src/app/shared/services/token.service";
const now = new Date();
import Swal from "sweetalert2/dist/sweetalert2.js";

@Component({
  selector: "app-cropdetails",
  templateUrl: "./cropdetails.component.html",
  styleUrls: ["./cropdetails.component.sass"],
})
export class CropdetailsComponent implements OnInit {
  @ViewChild("ngxLoading") ngxLoadingComponent: NgxLoadingComponent;
  @ViewChild("customLoadingTemplate") customLoadingTemplate: TemplateRef<any>;
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;

  @Input() cropDetailsArray;
  cropFormGroup: FormGroup;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  loading: boolean;
  groupName = this.tokenService.getGroup();
  globalImgUrl = this.authService.s3url();
  healthdiagnosis: any;
  cropdata: CropData[];
  pop: POP[];
  fobj: {
    group: string;
    profileId: string;
    maincropId: string;
    cropId: string;
    cropImages: any[];
    varietyImages: any[];
    numberOfVisits: number;
    cropCategory: string;
    cropName: string;
    varietyName: string;
    cropType: string;
    duration: number;
    varietyCode: string;
    cropDescription: string;
    endProductDescription: string;
    collectionData: any[];
    status: string;
  };
  fetchedToolList: any = [];
  harvestArray: any = [];
  sampling: string = "";
  mainCropID: string = "";
  cropID: string = "";
  showTable: boolean = false;
  finalBtntype: string = "save";
  numberOfVisits: number;
  profileUuid: string;
  harvestForm: FormGroup;
  harvestObj: { parameter: string; possibleValues: string; type: string };
  editHarvestRow: any[] = [];
  editHarvestObj: any = {};
  readOnly: boolean = true;
  rowReadOnly: any[] = [];
  popBtnColor = [];
  cropDataBtnColor = [];
  healthBtnColor = [];
  cropDataTool: CropDataTool;
  showVisits: boolean = false;
  dataSubmitingload: boolean;
  mainprofileArray: any = [];

  constructor(
    private _formBuilder: FormBuilder,
    private authService: AuthenticateService,
    private cropsService: CropsService,
    private tokenService: TokenStorageService,
    private profileService: ProfileService
  ) {}

  ngOnInit() {
    this.globalImgUrl = this.authService.s3url();
    this.profileService.getProfileData.subscribe((data) => {
      this.mainprofileArray = data.mainProfile;
      this.pop = data.pop;
      this.cropdata = data.crop;
      this.healthdiagnosis = data.health;
      this.popBtnColor = data.popBtnColor;
      this.cropDataBtnColor = data.cropDataBtnColor;
      this.healthBtnColor = data.popBtnColor;
    });
    this.pop = [];
    this.cropdata = [];
    this.healthdiagnosis = [];
    this.harvestObj = {
      parameter: "",
      possibleValues: "",
      type: "",
    };
    this.fobj = {
      group: "",
      profileId: "",
      maincropId: "",
      cropId: "",
      cropImages: [],
      varietyImages: [],
      numberOfVisits: 0,
      cropCategory: "",
      cropName: "",
      varietyName: "",
      cropType: "",
      duration: 0,
      varietyCode: "",
      cropDescription: "",
      endProductDescription: "",
      collectionData: [],
      status: "",
    };
    this.cropFormGroup = this._formBuilder.group({
      cropCategory: ["", Validators.required],
      varietyName: ["", Validators.required],
      cropname: ["", Validators.required],
      varietyCode: ["", Validators.required],
      cropType: ["", Validators.required],
      duration: ["", Validators.required],
      cropDescription: ["", Validators.required],
      endProductDescription: ["", Validators.required],
    });
    this.harvestForm = this._formBuilder.group({
      parameter: ["", Validators.required],
      type: ["", Validators.required],
    });
    setTimeout(() => {
      this.getToolData(this.cropDetailsArray);
    }, 200);
  }

  ngOnChanges() {
    this.cropFormGroup = this._formBuilder.group({
      cropCategory: ["", Validators.required],
      varietyName: ["", Validators.required],
      cropname: ["", Validators.required],
      varietyCode: ["", Validators.required],
      cropType: ["", Validators.required],
      duration: ["", Validators.required],
      cropDescription: ["", Validators.required],
      endProductDescription: ["", Validators.required],
    });
    this.harvestForm = this._formBuilder.group({
      parameter: ["", Validators.required],
      type: ["", Validators.required],
    });
  }

  addHarvest() {
    this.showTable = true;
    this.harvestObj["possibleValuesArray"] =
      this.harvestObj.possibleValues.split(",");
    this.harvestArray.push({
      parameter: this.harvestObj.parameter,
      possibleValues: this.harvestObj.possibleValues,
      possibleValuesArray: this.harvestObj["possibleValuesArray"],
      type: this.harvestObj.type,
    });
    console.log("harvestArray", JSON.stringify(this.harvestArray));
    this.harvestForm.reset();
    this.harvestObj = { parameter: "", possibleValues: "", type: "" };
  }

  deleteHarvestRow(index) {
    console.log("Deleted!");
    this.harvestArray.splice(index, 1);
  }

  updateHarvestRow(updateIndex) {
    this.harvestArray[updateIndex].parameter = this.editHarvestObj.parameter;
    this.harvestArray[updateIndex].possibleValues =
      this.editHarvestObj.possibleValues;
    this.harvestArray[updateIndex].possibleValuesArray =
      this.editHarvestObj.possibleValues.split(",");
    // this.harvestArray[updateIndex].possibleValuesArray = this.editHarvestObj.possibleValuesArray;
    this.harvestArray[updateIndex].type = this.editHarvestObj.type;
    this.editHarvestRow = [];
    this.editHarvestRow[updateIndex] = false;
  }

  cancelHarvestRow(cancelIndex) {
    this.editHarvestRow = [];
    this.editHarvestRow[cancelIndex] = false;
  }

  editHarvestRowData(editIndex) {
    this.editHarvestRow = [];
    this.rowReadOnly = [];
    this.editHarvestRow[editIndex] = true;
    this.rowReadOnly[editIndex] =
      this.harvestArray[editIndex].type == "Textbox" ? true : false;
    this.editHarvestObj = this.harvestArray[editIndex];
    this.editHarvestObj.type = this.harvestArray[editIndex].type;
    console.log("editHarvest", this.editHarvestObj);
  }

  selectType(type) {
    console.log("type", type);
    this.readOnly = type == "Textbox" ? true : false;
  }

  getToolData(variety) {
    this.fobj = {
      group: "",
      profileId: "",
      maincropId: "",
      cropId: "",
      numberOfVisits: 0,
      cropImages: [],
      varietyImages: [],
      cropCategory: "",
      cropName: "",
      varietyName: "",
      cropType: "",
      duration: 0,
      varietyCode: "",
      cropDescription: "",
      endProductDescription: "",
      collectionData: [],
      status: "",
    };
    this.cropFormGroup.reset();
    var varietyobj = {
      cropId: variety.cropId,
      group: this.groupName,
    };
    var cropobj = {
      maincropId: variety.maincropId,
      group: this.groupName,
    };
    console.log("variety = ", variety);
    this.fetchedToolList = [];
    this.harvestArray = [];
    this.sampling = "";
    this.cropsService.getCropByCategory(cropobj).then((cropdata: any) => {
      if (cropdata.length > 0) {
        this.fobj.cropImages = cropdata[0].cropImages;
      } else {
        this.fobj.cropImages = [];
      }
    });
    this.profileService.getTooldata(varietyobj).then((data: any) => {
      console.log("getTooldata = ", data);
      if (data.length > 0) {
        this.fetchedToolList = data;
        this.mainCropID = variety.maincropId;
        this.cropID = variety.cropId;
        if (data[0].harvestData) {
          this.harvestArray = data[0].harvestData["harvestParams"];
          for (let i = 0; i < this.harvestArray.length; i++) {
            this.harvestArray[i].possibleValues = this.harvestArray[
              i
            ].possibleValuesArray
              .map((item) => item)
              .join(",");
            console.log("possibleValues", this.harvestArray.possibleValues);
          }
          console.log("harvestArray", this.harvestArray);
          this.showTable = true;
          this.sampling = data[0].harvestData.sampling;
        }
        this.fobj.varietyName = variety.varietyName;
        this.fobj.cropType = variety.cropType;
        this.fobj.duration = variety.duration;
        this.fobj.cropImages = variety.cropImages;
        this.fobj.varietyCode = variety.varietyCode;
        this.fobj.cropCategory = variety.cropCategory;
        this.fobj.varietyImages = variety.cropImages;
        this.fobj.cropName = variety.cropName;
        this.fobj.cropDescription = data[0].cropDescription;
        this.fobj.endProductDescription = data[0].endProductDescription;
        this.numberOfVisits = data[0].collectionData.length;
        this.profileUuid = data[0].profileId;
        this.finalBtntype = "update";
      } else {
        this.mainCropID = variety.maincropId;
        this.cropID = variety.cropId;
        this.fobj.varietyName = variety.varietyName;
        this.fobj.cropType = variety.cropType;
        this.fobj.duration = variety.duration;
        this.fobj.varietyCode = variety.varietyCode;
        this.fobj.cropCategory = variety.cropCategory;
        this.fobj.cropImages = variety.cropImages;
        this.fobj.varietyImages = variety.cropImages;
        this.fobj.cropName = variety.cropName;
        this.profileUuid = undefined;
        this.numberOfVisits = 0;
        this.finalBtntype = "save";
      }
    });
  }

  handleInput(e) {
    if (e.which === 32 && e.target.selectionStart === 0) {
      return false;
    }
  }

  numericOnly(event): boolean {
    let patt = /^([0-9])$/;
    let result = patt.test(event.key);
    return result;
  }

  cropDetailsave() {
    for (let i = 0; i < this.harvestArray.length; i++) {
      delete this.harvestArray[i].possibleValues;
      this.harvestArray[i].orderId = i + 1;
      if (this.harvestArray[i].type == "Textbox") {
        delete this.harvestArray[i].possibleValuesArray;
      }
    }
    let harvestData = {
      harvestParams: this.harvestArray,
      sampling: this.sampling,
    };
    console.log("harvest Data : ", JSON.stringify(harvestData));
    this.popBtnColor = [];
    this.cropDataBtnColor = [];
    this.healthBtnColor = [];
    this.sampling = "";
    this.harvestArray = [];
    if (this.profileUuid == undefined) {
      this.profileUuid = UUID.UUID();
    }
    this.fobj.group = this.groupName;
    this.fobj.profileId = this.profileUuid;
    this.fobj.cropId = this.cropID;
    this.fobj.maincropId = this.mainCropID;
    this.fobj["harvestData"] = harvestData;
    this.showVisits = true;
    this.cropDataTool = this.fobj;
    console.log(
      "Crop details result #first page : ",
      JSON.stringify(this.cropDataTool)
    );
  }

  SubmitProfile() {
    console.log(
      "Filled list array ",
      this.popBtnColor,
      this.cropDataBtnColor,
      this.healthBtnColor
    );
    if (
      this.cropDataBtnColor.includes(false) ||
      this.popBtnColor.includes(false) ||
      this.healthBtnColor.includes(false)
    ) {
      this.fobj.status = "INPROGRESS";
    } else {
      this.fobj.status = "COMPLETED";
    }
    this.fobj.collectionData = this.mainprofileArray;

    this.cropDataTool = this.fobj;
    console.log("Profile Json ", JSON.stringify(this.cropDataTool));
    console.log("pop data", this.pop, this.cropdata, this.healthdiagnosis);

    this.pop.forEach((element) => {
      this.profileService.postPOP(element).then((data: any) => {
        console.log("pop data", data);
      });
    });

    this.cropdata.forEach((element) => {
      this.profileService.postCropdata(element).then((data: any) => {
        console.log("crop data", data);
      });
    });

    this.healthdiagnosis.forEach((element) => {
      this.profileService.postHealthCollection(element).then((data: any) => {
        console.log("crop data", data);
      });
    });

    this.profileService.postProfile(this.cropDataTool).then((data: any) => {
      console.log("Profile data : ", data);
    });
    setTimeout(() => {
      this.profileService.gotoMainpage();
    }, 2000);
  }

  updateProfile() {
    this.dataSubmitingload = true;
    console.log(
      "Filled list array ",
      this.popBtnColor,
      this.cropDataBtnColor,
      this.healthBtnColor
    );
    if (
      this.cropDataBtnColor.includes(false) ||
      this.popBtnColor.includes(false) ||
      this.healthBtnColor.includes(false)
    ) {
      this.fobj.status = "INPROGRESS";
    } else {
      this.fobj.status = "COMPLETED";
    }
    this.fobj.collectionData = this.mainprofileArray;
    this.cropDataTool = this.fobj;
    console.log("update Profile Json ", this.cropDataTool);
    console.log("Profile ", this.cropDataTool.collectionData);
    if (this.cropDataTool["id"]) delete this.cropDataTool["_id"];
    this.profileService.updateProfile(this.cropDataTool).then((data: any) => {
      if (data["result"] == "SUCCESS") {
        Swal({ title: "Updated successfully!" });
        console.log("Profile data last : ", data);
        this.dataSubmitingload = false;
        this.profileService.gotoMainpage();
      }
    });
  }
}
